<div [class]="FORM_STYLE_CONFIG.formGroup.default" [ngClass]="formGroupClass">
	<!-- <div [class]="FORM_STYLE_CONFIG.formGroup.default" [ngClass]="{'padding-null': !isNormalForm}"> -->
	<!-- <div [class]="FORM_STYLE_CONFIG.formGroup.default" [ngClass]="{'padding-null': !isNormalForm}"> -->
	<div [ngClass]="isNormalForm ? FORM_STYLE_CONFIG.formGroup.portlet.condition.normalForm : ''">
		<!-- <div [ngClass]="{'m-portlet': isNormalForm}"> -->
		<div *ngIf="label" [class]="FORM_STYLE_CONFIG.formGroup.portlet.head.default">
			<div [class]="FORM_STYLE_CONFIG.formGroup.portlet.head.caption.default">
				<div [class]="FORM_STYLE_CONFIG.formGroup.portlet.head.caption.title.default">
						<!-- <div class="m-portlet__head-title"> -->
					<!-- <span class="m-portlet__head-icon m--hide">
						<i class="la la-gear"></i>
					</span> -->
					<h3 [class]="FORM_STYLE_CONFIG.formGroup.portlet.head.caption.title.label.default">
							<!-- <h3 class="m-portlet__head-text label-style"> -->
						<p>{{label}}</p>
					</h3>
				</div>
			</div>
			<div class="back-button"*ngIf="formArray?.backButton">
				<button type="button"(click)="goBack()" class="btn btn-secondary m-btn m-btn--custom m-btn--outline-2x button-round">
					Back
				</button>
			</div>
		</div>
		<div [class]="FORM_STYLE_CONFIG.formGroup.portlet.body.default" [ngClass]="formClass">
			<!-- <div [class]="FORM_STYLE_CONFIG.formGroup.portlet.body.default" [ngClass]="{'padding-null margin-top-negative-50':isModalForm, 'padding-null':isWithoutStyle, 'form-padding':isNormalForm}"> -->
			<app-d-form *ngFor="let form of formGroup" [options]="styleOptions" (formBuildCompleted)="onFormBuildCompleted()" [disable]="disable" (change)="onChange()" [(formRef)]="form.formRef" [formElements]="form.formElements"
			 [label]="form.label" [name]="form.label" [type]="form.type"></app-d-form>
		</div>
	</div>
		<ng-container *ngIf="submitText || cancelText">
			<div [ngClass]="{'button-right': formArray.direction == 'anti', 'align-center': formArray.direction == 'center'}" class="margin-top-30">
				<hr>
				<button *ngIf="submitText && disableSubmit" [class]="FORM_STYLE_CONFIG.formGroup.portlet.button.submit.default" (click)="onSubmit()">{{submitText}}</button>
				<button *ngIf="submitText && !disableSubmit" data-dismiss="modal" [class]="FORM_STYLE_CONFIG.formGroup.portlet.button.submit.default" (click)="onSubmit()">{{submitText}}</button>
				<button *ngIf="cancelText" data-dismiss="modal" data-dismiss="modal" [class]="FORM_STYLE_CONFIG.formGroup.portlet.button.cancel.default" (click)="onCancel()">{{cancelText}}</button>
			</div>
		</ng-container>
</div>
